export const isNotNullOrEmpty = (val?: any) => {
  if (val === undefined || val === null) {
    return false;
  } else if (typeof val === 'string' && val.trim() === '') {
    return false;
  }

  return true;
};
